export default __webpack_public_path__ + "static/3-63a3ae3a2e69e5c64375bc24ffd148e5.jpg";